import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { useAppDispatch } from "@/hooks/useRedux";
import { setSnackBarMsjSucceded } from "@/store/slices/auth/actions";

interface ICopyCoordinatesButton {
  coordinates: string;
  size?: "small" | "medium" | "large";
  tooltipTitle?: string;
  sx?: any;
}

export default function CopyCoordinatesButton({
  coordinates,
  size = "small",
  tooltipTitle = "Copy coordinates",
  sx,
}: ICopyCoordinatesButton) {
  const dispatch = useAppDispatch();

  const handleCopyCoordinates = () => {
    navigator.clipboard.writeText(coordinates);
    dispatch(
      setSnackBarMsjSucceded({
        state: true,
        type: "success",
        msj: "Coordinates copied!",
      }),
    );
  };

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        size={size}
        sx={{ color: "primary.main", p: 0.5, ...sx }}
        onClick={handleCopyCoordinates}
      >
        <ContentCopy fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
